import { PolePatch } from '../types/planBT.types'
import { checkValidity } from '../../../common/utils/inputValidityChecker'

export  interface  ErrorInputPole{
    isErrorName?: boolean,
    isErrorNumber?: boolean,
    isErrorLat?: boolean,
    isErrorLng?: boolean
}

export default function validationPoleCheck(pole: PolePatch) : ErrorInputPole | null {
   let  errorInputPole = {}
   let haveError = false
   if(!checkValidity(pole.pole_name || '', 'text-not-empty')){
       errorInputPole = {...errorInputPole, isErrorName: true}
       haveError = true
   }
    if(!checkValidity(pole.pole_number || '', 'text-not-empty')){
         errorInputPole = {...errorInputPole, isErrorNumber: true}
         haveError = true
    }
    if(!checkValidity(pole.pole_location_lat || '', 'number-float')){
        errorInputPole = {...errorInputPole, isErrorLat: true}
        haveError = true
    }
    if(!checkValidity(pole.pole_location_lng || '', 'number-float')){
        errorInputPole = {...errorInputPole, isErrorLng: true}
        haveError = true
    }
    if(haveError){
        return errorInputPole
    }
    
    return null
}
